
export const AUDIT_STATUS_TYPE = Object.freeze({
  0: '审核通过',
  1: '审核中',
  2: '审核不通过'
})

